export default "__VITE_ASSET__BcYnrXfb__"